import { useStore } from '@nanostores/react'
import { $conversations } from 'features/messaging/model/stores'
import { computed } from 'nanostores'

import { store as actionsStore } from '../utils'

const $activeConversation = computed(
	[actionsStore.openId, $conversations],
	(openId, conversations) => conversations[openId]
)

/**
 * Revive opened conversation info
 */
export const useConversation = () => useStore($activeConversation)
